export default (state = [], action) => {
  switch (action.type) {
    case 'SET_LIST_FLIGHT_STAT':
      return action.data
    default:
      return state
  }
}